<!-- version 2021/05/20 -->
<template>
  <div class="l_cln_medical_interviews">
    <div class="m_cln_medical_interviews_photo">
        <app-label-text title=""></app-label-text>
        <img :src="imageurl" class="">
    </div>
  </div>
</template>

<script>
    export default {
        props: {
            imageurl: String
        }
    }
</script>

<style lang="sass" scoped>
    img
        border-radius: 6px
        width: 100%
        height: auto
    label
        min-width: 120px

</style>
